import { useState } from 'react';
import styled from 'styled-components';
import Button from 'components/atoms/Button';
import LenteNewsletterSubscribeForm from 'components/newsletter';
import { Modal } from 'antd';

export default function NewsletterForm({ onValidated, isMobile, status }) {
    const [isVisibleModalCancel, setIsVisibleModalCancel] = useState(false);
    const showModal = () => {
      setIsVisibleModalCancel(true);
    };
    const handleClose = () => {
      setIsVisibleModalCancel(false);
    };
    return (
        <NewsletterStyled style={{ height: '100%' }}>
           <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
              <CustomButton onClick={showModal} dark>
                 Receber Avisos
              </CustomButton>
               <Modal
                  open={isVisibleModalCancel}
                  onCancel={handleClose}
                  footer={null}
                  centered
               >
                  <LenteNewsletterSubscribeForm url={null}/>
               </Modal>
           </div>
        </NewsletterStyled>
    );
}

const NewsletterStyled = styled.div`
    label {
        width: 100%;
        @media (min-width: 768px) {
            max-width: 363px;
        }
    }
`;


const CustomButton = styled(Button)`
    @media (min-width: 768px) {
        max-width: 363px;
    }
`;
